/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendContractResponseDto
 */
export interface SendContractResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof SendContractResponseDto
     */
    isSuccess: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendContractResponseDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractResponseDto
     */
    documentId?: string;
}

/**
 * Check if a given object implements the SendContractResponseDto interface.
 */
export function instanceOfSendContractResponseDto(value: object): value is SendContractResponseDto {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SendContractResponseDtoFromJSON(json: any): SendContractResponseDto {
    return SendContractResponseDtoFromJSONTyped(json, false);
}

export function SendContractResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendContractResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'message': json['message'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
    };
}

export function SendContractResponseDtoToJSON(json: any): SendContractResponseDto {
    return SendContractResponseDtoToJSONTyped(json, false);
}

export function SendContractResponseDtoToJSONTyped(value?: SendContractResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'message': value['message'],
        'documentId': value['documentId'],
    };
}

